import React from 'react';
import { faCircle } from '@fortawesome/pro-solid-svg-icons/faCircle';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function CircleSolidIcon(
  props: React.PropsWithChildren<React.HTMLAttributes<SVGElement>>
) {
  return <FontAwesomeIcon icon={faCircle} {...props} />;
}
